import { render, staticRenderFns } from "./AppPageFootBar.vue?vue&type=template&id=3a0d0d46&scoped=true&"
import script from "./AppPageFootBar.vue?vue&type=script&lang=js&"
export * from "./AppPageFootBar.vue?vue&type=script&lang=js&"
import style0 from "./AppPageFootBar.vue?vue&type=style&index=0&id=3a0d0d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0d0d46",
  null
  
)

export default component.exports